module.exports = __webpack_public_path__ + "img/20200515_161923.87023e25.jpg";